import React from 'react';
import { useNavigate } from 'react-router-dom';
import AddQuizEvaluation from './AddQuizEvaluation';
import { useAuth } from '../../Context/AuthContext';
import { useGetUserQuery } from '../../services/SkillsManagement';

const TakeAssignedQuiz = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const employeeId = Number(user?.id);
  const shouldSkipUser = !Number.isFinite(employeeId);
  const { data: userResp } = useGetUserQuery(
    { userId: String(employeeId || '') },
    { skip: shouldSkipUser }
  );

  const posteObj = userResp?.user?.Poste || userResp?.user?.poste || null;
  const posteId = posteObj?.posteId || userResp?.user?.posteId || userResp?.posteId || user?.posteId || null;

  return (
    <AddQuizEvaluation
      open={true}
      onClose={() => navigate('/my-evaluation', { replace: true })}
      posteId={posteId}
      initialViewMode="assigned"
    />
  );
};

export default TakeAssignedQuiz;
